import { useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import { showLoader, hideLoader } from 'store/uiSlice';
import { authService } from 'api/auth';
import { ChangePasswordPayload } from 'types/auth';

export const useProfile = () => {
  const dispatch = useAppDispatch();
  const [apiError, setApiError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const changePassword = async (payload: ChangePasswordPayload, showGlobalLoader = true) => {
    setApiError('');
    setSuccessMessage('');
    try {
      if (showGlobalLoader) dispatch(showLoader());
      await authService.changePassword(payload);
      setSuccessMessage('Password successfully changed');
      return true;
    } catch (err: any) {
      setApiError(err.response?.data?.message || 'Failed to change password. Please try again.');
      return false;
    } finally {
      if (showGlobalLoader) dispatch(hideLoader());
    }
  };

  const fetchLoginHistory = async (
    page = 1,
    limit = 10,
    sortField = 'id',
    sortValue = 'DESC',
    showGlobalLoader = true,
  ) => {
    setApiError('');
    try {
      if (showGlobalLoader) dispatch(showLoader());
      const response = await authService.getLoginHistory(page, limit, sortField, sortValue);
      return response.data;
    } catch (err: any) {
      setApiError(err.response?.data?.message || 'Failed to fetch login history.');
      return null;
    } finally {
      if (showGlobalLoader) dispatch(hideLoader());
    }
  };

  return {
    changePassword,
    fetchLoginHistory,
    apiError,
    setApiError,
    successMessage,
    setSuccessMessage,
  };
};
